import { render, staticRenderFns } from "./UpcomingBookings.vue?vue&type=template&id=2625a63f&scoped=true&"
import script from "./UpcomingBookings.vue?vue&type=script&lang=ts&"
export * from "./UpcomingBookings.vue?vue&type=script&lang=ts&"
import style0 from "./UpcomingBookings.vue?vue&type=style&index=0&id=2625a63f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625a63f",
  null
  
)

export default component.exports